import { Layout } from "@jambushrushti/components/layout/Layout";
import { Seo } from "@jambushrushti/components/shared/Seo";
import { HeroSection } from "@jambushrushti/components/home/HeroSection";
import { AboutPreview } from "@jambushrushti/components/home/AboutPreview";
import { ResearchToolsSection } from "@jambushrushti/components/home/ResearchToolsSection";
import { GuruvaniPreview } from "@jambushrushti/components/home/GuruvaniPreview";
import { CommunitySection } from "@jambushrushti/components/home/CommunitySection";
import { AdaniFoundation } from "@jambushrushti/components/home/AdaniFoundation";

const Index = () => {
  return (
    <Layout>
      <Seo />
      <div className="bg-background">
        <HeroSection />
        <ResearchToolsSection />
        <AboutPreview />
        <GuruvaniPreview />
        <AdaniFoundation />
        <CommunitySection />
      </div>
    </Layout>
  );
};

export default Index;
